import * as React from "react";
import { observer } from "mobx-react";
import { SpedApuracaoStore } from "../../stores/sped/SpedApuracaoStore";
import { Alert, Alignment, Button, Classes, Dialog, FormGroup, HTMLSelect, Tab, Tabs } from "@blueprintjs/core";
import { MDBBtn, MDBCol, MDBRow } from "mdbreact";
import { observable } from "mobx";
import { formatCnpj } from "../../utils";
import { IEmpresa, newEmpresa } from "../../model";
import { toast } from "react-toastify";

import { EmpresaSelect, filterEmpresa, renderEmpresa } from "../empresa/EmpresaSelect";
import { EmpresaStore } from "../../stores/empresa/EmpresaStore";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { ptBR } from '@mui/x-date-pickers/locales';
import moment from "moment";
import dayjs from "dayjs";
import DeiTable from "./DeiTable";
import { LookupStore } from "../../stores/LookupStore";
import Cookies from 'universal-cookie';
import { SpedStore } from "../../stores/sped/SpedStore";
import { AppStore } from "../../stores/AppStore";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import LoadingModal from "../loading/LoadingModal";
import { DaeAvulsoStore } from "../../stores/dae-avulso/DaeAvulsoStore";
import { getTag } from "../utils/getStatus";
import { Pager } from "../utils/Pager";
import { DeiStore } from "../../stores/dei/DeiStore";
import { DateRangePicker } from "../utils/DateRangePicker";

const cookies = new Cookies()

@observer
export default class DeiPage extends React.Component<{}, {}> {

  obs = observable({
    arquivosSefip: [] as any[],
    tarefas_page: 1 as number,
    uuid: "" as string,
    view_erros: false as boolean,
    date_start: "" as string,
    date_end: "" as string,
    erros: [] as any,
    viewArquivos: false as boolean,
    tabAtiva: "dei"
  })

  constructor(props: any) {
    super(props);
    AppStore.setTitle("DEI");
  }

  /**
   * Ao montar o componente, verifica se existe o cookie "__DAE-DEI".
   * Se existir, restaura as informações salvas (abas, empresa, período,
   * modelo e data) nos stores e realiza a busca de dados DEI.
   * Após isso, o cookie é removido.
   */
  async componentDidMount() {

    DaeAvulsoStore.obs.selectEmpresaDae = newEmpresa()
    DaeAvulsoStore.obs.selectedPeriodDae = []
    DaeAvulsoStore.obs.tasks_dae_avulso = []
    DaeAvulsoStore.obs.tasks_dae_length = 0

    const hoje = new Date();

    this.obs.date_start = moment(hoje).format("YYYY-MM-DD");
    this.obs.date_end = moment(hoje).format("YYYY-MM-DD");

    DaeAvulsoStore.obs.selectedPeriodDae = [
      hoje,
      hoje
    ];

    const cookies_data = cookies.get('__DAE-DEI');

    if (cookies_data && cookies_data.tab == "dei") {

      SpedStore.obs.selectedTab = "apuracao"

      SpedApuracaoStore.obs.selectedTab = "dei"

      SpedApuracaoStore.obs.selectedEmpresaDei = cookies_data.empresa

      SpedApuracaoStore.obs.periodoDei = cookies_data.periodo

      SpedApuracaoStore.obs.modelo = cookies_data.modelo

      SpedApuracaoStore.obs.dataDei = dayjs(moment(cookies_data.date_start).add(3, "hours").toDate())

      await LookupStore.loadIcmsClassificacoes(SpedApuracaoStore.obs.selectedEmpresaDei.uf);

      await SpedApuracaoStore.handleBuscaDei(SpedApuracaoStore.obs.selectedEmpresaDei, SpedApuracaoStore.obs.periodoDei, SpedApuracaoStore.obs.modelo)

      cookies.remove('__DAE-DEI');

    }

  }

  /**
 * Realiza a busca da apuração de ICMS, verificando as condições necessárias antes de efetuar a requisição de dados.
 * 
 * A função verifica os seguintes itens:
 * - Se a empresa foi selecionada (CNPJ).
 * - Se o período de apuração é válido.
 * - Se o ano do período de apuração é válido (não inferior a 2000).
 * - Se a UF da empresa foi selecionada.
 * 
 * Caso alguma dessas condições não seja atendida, a execução é interrompida com o devido tratamento, como exibição de mensagens de aviso.
 * 
 * Após a validação, a função realiza duas operações assíncronas:
 * 1. Carrega as classificações de ICMS para a UF da empresa selecionada.
 * 2. Busca os dados de apuração para a empresa e período selecionados.
 * 
 * @returns {Promise<void>} Retorna uma promise que resolve sem valor após a execução das operações assíncronas. Não há valor de retorno, pois a função apenas realiza a busca e manipulação de dados de apuração.
 */
  async handleBuscaApuracao() {

    if (!SpedApuracaoStore.obs.selectedEmpresaDei.cnpj) {
      toast.warning('Selecione uma empresa.', {});
      return
    }

    if (!SpedApuracaoStore.obs.periodoDei || SpedApuracaoStore.obs.periodoDei.includes("Data inválida") || SpedApuracaoStore.obs.periodoDei.includes(null) || SpedApuracaoStore.obs.periodoDei.includes("")) {
      return
    }

    if (parseInt(moment(SpedApuracaoStore.obs.periodoDei[0]).format("YYYY")) < 2000) return
    if (parseInt(moment(SpedApuracaoStore.obs.periodoDei[0]).format("YYYY")) < 2000) return

    await LookupStore.loadIcmsClassificacoes(SpedApuracaoStore.obs.selectedEmpresaDei.uf);

    await SpedApuracaoStore.handleBuscaDei(SpedApuracaoStore.obs.selectedEmpresaDei, SpedApuracaoStore.obs.periodoDei, SpedApuracaoStore.obs.modelo)

  }

  /**
     * Formata a data e hora, adicionando 3 horas e exibindo no formato "DD/MM/YYYY ÁS HH:mm".
     * 
     * @param {any} cell - A célula contendo a data a ser formatada.
     * @param {Object} row - A linha de dados (não utilizada nesta função).
     * @returns {string} A data formatada com a hora.
     */
  dateFormatter = (cell, row) => {

    return moment(cell).add(3, "hour").format("DD/MM/YYYY") + " ÁS " + moment(cell).add(3, "hour").format("HH:mm");

  };

  /**
   * Fecha modal dos erros.
   */
  onCloseErros() {
    this.obs.view_erros = false
    this.obs.erros = []
  }

  /**
   * Função responsável por formatar o valor de status em uma tag visual.
   * Ela utiliza a função `getTag` para mapear o valor do status da linha (`row.status`) 
   * para uma representação visual, como uma tag ou marcador, que será exibida no componente.
   *
   * @param {any} cell - O valor da célula, que neste caso não é utilizado na lógica, mas é exigido pela assinatura do formato de célula.
   * @param {Object} row - A linha de dados contendo a propriedade `status`, usada para determinar o tipo de tag a ser exibida.
   * @returns {React.Element} Retorna um componente visual (uma tag) que representa o status da linha.
   */
  statusFormatter = (cell, row) => {

    return getTag(row.status);

  }

  /**
 * Atualiza o período de apuração com base no valor recebido e aciona a busca de apuração.
 * 
 * A função realiza a seguinte operação:
 * - Recebe um valor (provavelmente um objeto de data) e extrai a data do valor, caso seja válida.
 * - Atualiza a propriedade `dataDei` no `SpedApuracaoStore`.
 * - Calcula o período de início e fim do mês da data recebida, formatando os valores no formato "YYYY-MM-DD".
 * - Atualiza a propriedade `periodoDei` no `SpedApuracaoStore` com as novas datas de início e fim do mês.
 * - Chama a função `handleBuscaApuracao` para buscar os dados de apuração com base nas novas configurações de período.
 * 
 * @param {Object} value O valor da data, que pode ser um objeto de data (como um objeto Moment.js ou similar) com uma propriedade `$d`.
 * 
 * @returns {Promise<void>} Retorna uma promise que resolve sem valor após a execução da busca de apuração.
 */
  async handlePeriodo(value) {

    const data = value && value.$d ? value.$d : ""

    SpedApuracaoStore.obs.dataDei = value

    SpedApuracaoStore.obs.periodoDei = [moment(data).startOf("month").format("YYYY-MM-DD"), moment(data).endOf("month").format("YYYY-MM-DD")]

    this.handleBuscaApuracao()

  }

  /**
   * Função responsável por fazer o download de um arquivo específico associado a uma linha de dados.
   * Utiliza o `uuid` do DAE, o nome do arquivo e o `id` do arquivo para realizar o download.
   * 
   * @param {Object} row - A linha de dados contendo as informações do arquivo, incluindo `nome` e `id`.
   */
  handleDownloadArquivo = async (row: any) => {
    await DaeAvulsoStore.downloadArquivoNivy(this.obs.uuid, row.nome, row.id);
  };

  /**
  * Função responsável por renderizar os botões para download e visualização de arquivos.
  * Exibe um botão de download e, se o arquivo for um PDF, exibe também o botão para visualizá-lo.
  * 
  * @param {any} cell - O valor da célula (não utilizado nesta função).
  * @param {Object} row - A linha de dados contendo as informações do arquivo, incluindo `nome` e `id`.
  * @returns {JSX.Element} Dois botões: um para download e outro para visualização (se o arquivo for PDF).
  */
  buttonFormatterArquivo = (cell, row) => {
    return (
      <>
        <MDBBtn
          color="default"
          rounded
          size="sm"
          onClick={() => this.handleDownloadArquivo(row)}
        >
          <img src="/images/download.svg" />
        </MDBBtn>
      </>
    );
  }

  /**
 * Formata os botões de ação para detalhes e arquivos.
 * O primeiro botão exibe detalhes ao ser clicado e o segundo só é habilitado
 * se o status da linha for "Concluído" ou 2.
 * 
 * @param {any} cell - O valor da célula (não utilizado nesta função).
 * @param {Object} row - A linha de dados contendo o status e outras informações.
 * @returns {JSX.Element} Dois botões renderizados para interações: um para visualizar detalhes e outro para visualizar arquivos.
 */
  buttonFormaterDetalhes = (cell, row) => {
    return (
      <>
        <MDBBtn
          color="default"
          rounded
          size="sm"
          onClick={(e) => this.handleViewDetalhes(row)}
        >
          <img src="/images/view.png" width="18px" />
        </MDBBtn>
        <MDBBtn
          disabled={!["Concluído", 2].includes(row.status)}
          color="default"
          rounded
          size="sm"
          onClick={(e) => this.handleViewArquivos(row)}
        >
          <img src="/images/detalhamento.png" width="18px" />
        </MDBBtn>
      </>
    );
  }

  format_receitas = (cell, row) => {

    if (!cell) return ""

    return cell.map(x => {

      return Object.entries(x).map(([campo, valor]) => {

        return campo

      })

    })

  }

  /**
     * Atualiza o número da página e consulta as solicitações com base na páginação.
     * 
     * @param {number} page Número da página.
     */
  handleBuscaTarefasPaged = async (page: number) => {
    this.obs.tarefas_page = page
    DaeAvulsoStore.handleDaePaged(page, DaeAvulsoStore.obs.selectEmpresaDae.cnpj, this.obs.date_start, this.obs.date_end, "simples");
  };

  /**
     * Busca as solicitações com base no filtro.
     */
  handleBuscaTarefas = async () => {
    await DaeAvulsoStore.handleDaePaged(1, DaeAvulsoStore.obs.selectEmpresaDae.cnpj, this.obs.date_start, this.obs.date_end, "simples");
  };

  /**
     * Função responsável por manipular a alteração de datas da solicitação.
     * O valor é então formatado para o formato "YYYY-MM-DD" e atribuído às propriedades `date_start` e `date_end`.
     * @param {Date} val - A data representando um intervalo de datas. 
    */
  handleDateSolicitacaoChange = (val: Date) => {
    var string = val?.toString();
    var array = string.split(",");

    this.obs.date_start = moment(array[0]).format("YYYY-MM-DD")
    this.obs.date_end = moment(array[1]).format("YYYY-MM-DD")

    DaeAvulsoStore.obs.selectedPeriodDae = val;
  };

  /**
   * Função responsável por exibir os detalhes dos erros relacionados a uma linha de dados.
   * Ela verifica se o DAE é novo e busca os erros associados a ele. Caso contrário, realiza uma consulta para recuperar os erros.
   * Se não houver erros, exibe um aviso.
   * 
   * @param {Object} row - A linha de dados que contém as informações do DAE, incluindo possíveis erros.
   */
  handleViewDetalhes = async (row: any) => {

    DaeAvulsoStore.obs.loading_erros = true

    this.obs.erros = !row.error ? "" : row.error

    DaeAvulsoStore.obs.loading_erros = false

    if (this.obs.erros) {

      this.obs.view_erros = true

    } else {

      toast.warn("Nenhum erro encontrado!", {});
      return

    }

  };

  /**
   * Função responsável por exibir os arquivos associados a uma linha de dados.
   * Se o DAE for novo, faz o download do arquivo. Caso contrário, consulta os arquivos associados ao DAE.
   * Se arquivos forem encontrados, exibe os arquivos; caso contrário, exibe um aviso.
   * 
   * @param {Object} row - A linha de dados que contém as informações do DAE, incluindo `dae_new`, `task_id`, e `uuid`.
   */
  handleViewArquivos = async (row: any) => {

    if (row.tipo == "simples") {

      await DeiStore.downloadArquivo(DaeAvulsoStore.obs.selectEmpresaDae, row.task_id, this.format_receitas(row.receitas, row));

      // return

    } else {

      await DaeAvulsoStore.downloadArquivo(DaeAvulsoStore.obs.selectEmpresaDae, row.task_id);

    }

    // this.obs.arquivosSefip = await DaeAvulsoStore.consultaArquivo(row.uuid);

    // this.obs.uuid = row.uuid;

    // if (this.obs.arquivosSefip.length) {

    //   DaeAvulsoStore.obs.loadingDetalhes = false
    //   this.obs.viewArquivos = true;

    // } else {

    //   toast.warning('Sem Arquivos!', {});
    // }

    // DaeAvulsoStore.obs.loadingDetalhes = false

  };

  /**
 * Atualiza o modelo de apuração e aciona a busca de apuração.
 * 
 * A função recebe um modelo como parâmetro, atualiza o valor do modelo no `SpedApuracaoStore` e chama a função de busca de apuração (`handleBuscaApuracao`) para obter os dados com base no modelo atualizado.
 * 
 * @param {string} modelo O modelo de apuração a ser definido. Este valor será armazenado em `SpedApuracaoStore.obs.modelo`.
 * 
 * @returns {Promise<void>} Retorna uma promise que resolve sem valor após a execução da busca de apuração.
 */
  handleChangeModelo(modelo: string) {

    SpedApuracaoStore.obs.modelo = modelo

    this.handleBuscaApuracao()

  }

  /**
   * Função responsável por fazer o download de todos os arquivos associados ao DAE.
   * Utiliza o `uuid` do DAE e o CNPJ da empresa selecionada para realizar o download.
   */
  handleDownloadAll = async () => {
    await DaeAvulsoStore.downloadArquivosAll(this.obs.uuid, DaeAvulsoStore.obs.selectEmpresaDae.cnpj);
  };

  render() {

    let empresaText = SpedApuracaoStore.obs.selectedEmpresaDei.cnpj != ""
      ? `${SpedApuracaoStore.obs.selectedEmpresaDei.razao_social.substring(0, 38)}... (${formatCnpj(SpedApuracaoStore.obs.selectedEmpresaDei.cnpj)})`
      : "Selecione uma empresa";

    let empresaTarefasText = DaeAvulsoStore.obs.selectEmpresaDae.cnpj != ""
      ? `${DaeAvulsoStore.obs.selectEmpresaDae.razao_social.substring(0, 38)}... (${formatCnpj(DaeAvulsoStore.obs.selectEmpresaDae.cnpj)})`
      : "Selecione uma empresa";


    return (
      <>
        <Tabs
          className="tabsCalculos"
          selectedTabId={this.obs.tabAtiva}
          onChange={(tabId) => this.obs.tabAtiva = tabId as string}
        >

          <Tab
            id="dei"
            title="DEI"
            panel={
              <>
                <MDBRow style={{ display: "flex", width: "100%", marginBottom: "10px" }}>
                  <MDBCol md="4">
                    <FormGroup className="empresaSelect" label="Empresa">
                      <EmpresaSelect
                        items={EmpresaStore.sortedEmpresas}
                        itemRenderer={renderEmpresa}
                        itemPredicate={filterEmpresa}
                        onItemSelect={(e: IEmpresa) => {
                          SpedApuracaoStore.obs.selectedEmpresaDei = e;
                          this.handleBuscaApuracao();
                        }}
                        inputProps={{ placeholder: "Filtrar uma empresa" }}
                      >
                        <Button
                          text={empresaText}
                          rightIcon="double-caret-vertical"
                          alignText={Alignment.LEFT}
                        />
                      </EmpresaSelect>
                    </FormGroup>
                  </MDBCol>

                  <MDBCol md="2">
                    <FormGroup label="Período">
                      <LocalizationProvider
                        localeText={ptBR.components.MuiLocalizationProvider.defaultProps.localeText}
                        adapterLocale={"pt-br"}
                        dateAdapter={AdapterDayjs}
                      >
                        <DatePicker
                          value={SpedApuracaoStore.obs.dataDei}
                          className="input-data-apuracao"
                          views={['month', 'year']}
                          onChange={(value) => this.handlePeriodo(value)}
                          format="MM/YYYY"
                          slotProps={{ textField: { size: 'small' } }}
                        />
                      </LocalizationProvider>
                    </FormGroup>
                  </MDBCol>

                  <MDBCol md="2">
                    <FormGroup label="Modelo">
                      <HTMLSelect
                        disabled
                        onChange={(e) => this.handleChangeModelo(e.target.value)}
                        value={SpedApuracaoStore.obs.modelo}
                      >
                        <option value="NF-E">NF-E</option>
                      </HTMLSelect>
                    </FormGroup>
                  </MDBCol>

                </MDBRow>

                {(() => {
                  const empresaSelecionada = SpedApuracaoStore.obs.selectedEmpresaDei?.cnpj;
                  const periodoSelecionado = SpedApuracaoStore.obs.periodoDei;

                  if (!empresaSelecionada || !periodoSelecionado) return null;

                  const possuiImpostos =
                    Array.isArray(SpedApuracaoStore.obs.apuracoes_dei) &&
                    SpedApuracaoStore.obs.apuracoes_dei.length > 0;

                  return (
                    <DeiTable
                      item={SpedApuracaoStore.obs.apuracoes_dei}
                      possuiImpostos={possuiImpostos}
                      onTransmitir={() => this.obs.tabAtiva = "tarefas_dei"}
                    />
                  );

                })()}

                <div style={{ marginTop: 5, float: "right", marginBottom: 120 }} />
              </>
            }
          />

          <Tab
            id="tarefas_dei"
            title="Tarefas DEI"
            panel={
              <>

                <MDBRow>
                  <MDBCol md="3">
                    <FormGroup className="empresaSelect" label="Empresa">
                      <EmpresaSelect
                        items={EmpresaStore.sortedEmpresas}
                        itemRenderer={renderEmpresa}
                        itemPredicate={filterEmpresa}
                        onItemSelect={(e: IEmpresa) => {
                          DaeAvulsoStore.obs.selectEmpresaDae = e;
                          DaeAvulsoStore.obs.tasks_dae_avulso = [];
                          DaeAvulsoStore.obs.tasks_dae_length = 0;
                        }}

                        inputProps={{ placeholder: "Filtrar uma empresa" }}
                      >
                        <Button
                          text={empresaTarefasText}
                          rightIcon="double-caret-vertical"
                          alignText={Alignment.LEFT} />
                      </EmpresaSelect>
                    </FormGroup>
                  </MDBCol>
                  <MDBCol md="3">
                    <FormGroup label="Período" className="inputsPeriodoCalculos">
                      <DateRangePicker
                        onChange={this.handleDateSolicitacaoChange}
                        value={DaeAvulsoStore.obs.selectedPeriodDae}
                      />
                    </FormGroup>
                  </MDBCol>
                  <MDBCol md="3" className="buttonConsultaCalculo">
                    <Button
                      text="Buscar"
                      id="consultar"
                      intent="primary"
                      icon="tick"
                      onClick={() => this.handleBuscaTarefas()}
                      loading={DaeAvulsoStore.obs.loading_tasks}
                    />
                  </MDBCol>
                </MDBRow>
                <div>
                  <BootstrapTable className="TableDefault" ref="table" data={DaeAvulsoStore.obs.tasks_dae_avulso}>
                    <TableHeaderColumn dataField="id" isKey={true} hidden width="1%">#</TableHeaderColumn>
                    <TableHeaderColumn dataFormat={this.dateFormatter} dataField="inserted_at" width="20%">Data Criação</TableHeaderColumn>
                    <TableHeaderColumn dataField="data_referencia" width="15%">Data Referência</TableHeaderColumn>
                    <TableHeaderColumn dataField="receitas" dataFormat={this.format_receitas} width="15%">Cód. receita</TableHeaderColumn>
                    <TableHeaderColumn dataFormat={this.statusFormatter} width="30%">Status</TableHeaderColumn>
                    <TableHeaderColumn dataFormat={this.buttonFormaterDetalhes} width="15%">Detalhes</TableHeaderColumn>
                  </BootstrapTable>
                </div>

                <div style={{ marginTop: 5, float: "right", marginBottom: 120 }}>
                  <Pager
                    currentPage={this.obs.tarefas_page}
                    totalCount={DaeAvulsoStore.obs.tasks_dae_length}
                    pageSize={15}
                    onPageChange={page => this.handleBuscaTarefasPaged(page)} />
                </div>

                <Dialog
                  isOpen={this.obs.view_erros}
                  onClose={() => this.onCloseErros()}
                  title="Erros ocorridos"
                  className="dados-soli"
                >
                  <div className={Classes.DIALOG_BODY}>
                    <p>{this.obs.erros}</p>
                  </div>

                </Dialog>

                <Alert
                  confirmButtonText="Fechar"
                  isOpen={this.obs.viewArquivos}
                  onClose={() => this.obs.viewArquivos = false}
                  canOutsideClickCancel={true}
                  className="AlertUser"
                >
                  <h2 className="titleSEFAZ">Arquivos</h2>
                  <div className="heightArquivos">
                    <div style={{ marginBottom: 5, float: "right" }}>
                      <Button
                        icon="download"
                        text="Download Zip"
                        loading={DaeAvulsoStore.obs.loadingArquivoAll}
                        className="btn-file btnDefault noMargin"
                        onClick={() => this.handleDownloadAll()}
                      />
                    </div>

                    <BootstrapTable
                      className="nomeArquivos"
                      data={this.obs.arquivosSefip}
                      hover
                    >
                      <TableHeaderColumn
                        dataField="id"
                        isKey={true}
                        hidden
                        width="1%"
                      >
                        #
                      </TableHeaderColumn>
                      <TableHeaderColumn
                        dataFormat={this.buttonFormatterArquivo}
                        width="8%"
                      >
                      </TableHeaderColumn>
                      <TableHeaderColumn dataField="nome" dataSort={true} width="50%">
                        Arquivos
                      </TableHeaderColumn>
                    </BootstrapTable>
                  </div>
                </Alert>

                <LoadingModal open={DaeAvulsoStore.obs.loading_erros} onClose={() => DaeAvulsoStore.obs.loading_erros = false} title={"Buscando erros"} />
                <LoadingModal open={DaeAvulsoStore.obs.loading_arquivos} onClose={() => DaeAvulsoStore.obs.loading_arquivos = false} title={"Baixando arquivo"} />
                <LoadingModal open={DaeAvulsoStore.obs.loadingDetalhes} onClose={() => DaeAvulsoStore.obs.loadingDetalhes = false} title={"Carregando"} />
                <LoadingModal open={DaeAvulsoStore.obs.loadingViewArquivo} onClose={() => DaeAvulsoStore.obs.loadingViewArquivo = false} title={"Abrindo arquivo"} />
              </>

            }

          />
        </Tabs>
      </>

    );
  }
}